const AppLogoIconVoltex = (props: any) => {
  return (
    <svg
      width='201'
      height='71'
      viewBox='0 0 201 71'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M29.5763 64.5097C29.2967 58.986 24.7519 54.5811 19.1583 54.5811C13.5647 54.5811 9.01991 58.986 8.74023 64.5097H29.5763Z'
        fill='#F0E402'
      />
      <path
        d='M32.3031 23.1872L18.8785 19.1318L11.3271 34.0947L24.6119 37.9403L20.3468 59.7553L45.448 34.3045L30.4852 29.1304L32.3031 23.1872Z'
        fill='#95CDEE'
      />
      <path
        d='M11.4672 50.6657L6.43299 41.3663C6.15331 40.8769 6.36307 40.2476 6.85251 39.9679C7.34195 39.6883 7.97121 39.898 8.25089 40.3875L13.2851 49.6868C13.5648 50.1763 13.3551 50.8055 12.8656 51.0852C12.3762 51.3649 11.7469 51.1551 11.4672 50.6657Z'
        fill='#444B54'
      />
      <path
        d='M5.73376 56.3992L1.81824 54.0918C1.3288 53.8122 1.18896 53.1829 1.46864 52.6235C1.74832 52.1341 2.3776 51.9943 2.93696 52.2739L6.85248 54.5813C7.34192 54.861 7.48176 55.4902 7.20208 56.0496C6.85248 56.539 6.2232 56.6789 5.73376 56.3992Z'
        fill='#444B54'
      />
      <path
        d='M2.65731 63.9505L1.18899 63.531C0.559711 63.3912 0.210103 62.7619 0.349943 62.1326C0.489782 61.5034 1.11908 61.1537 1.67844 61.2936L3.14674 61.7131C3.77602 61.853 4.12562 62.4823 3.98578 63.1115C3.84594 63.7408 3.21667 64.0904 2.65731 63.9505Z'
        fill='#444B54'
      />
      <path
        d='M33.7716 56.399C33.5619 55.8397 33.7717 55.2803 34.331 55.0006L46.8467 49.7567C47.406 49.5469 47.9654 49.7566 48.2451 50.316C48.4548 50.8754 48.2451 51.4347 47.6857 51.7144L35.17 56.9584C34.6107 57.1682 34.0513 56.9584 33.7716 56.399Z'
        fill='#444B54'
      />
      <path
        d='M35.0302 63.391C35.0302 62.8317 35.5196 62.3422 36.079 62.3422L43.4206 62.2723C43.9799 62.2723 44.4694 62.7618 44.4694 63.3211C44.4694 63.8805 43.9799 64.3699 43.4206 64.3699L36.079 64.4398C35.4497 64.4398 35.0302 63.9504 35.0302 63.391Z'
        fill='#444B54'
      />
      <path
        d='M50.4126 64.2301C50.9533 64.2301 51.3915 63.7918 51.3915 63.2512C51.3915 62.7106 50.9533 62.2723 50.4126 62.2723C49.872 62.2723 49.4337 62.7106 49.4337 63.2512C49.4337 63.7918 49.872 64.2301 50.4126 64.2301Z'
        fill='#444B54'
      />
      <path
        d='M16.1519 6.96584L34.6806 11.5806C34.9603 11.6505 35.1001 11.9302 34.9603 12.2098L26.5699 29.7597C26.3601 30.1793 26.5699 30.7386 27.0593 30.8784L41.5328 34.6541C42.0222 34.794 42.0222 35.0037 41.7425 35.3533L22.4447 56.609C22.165 56.9586 21.6056 56.609 21.7455 56.1894L26.2203 39.8981C26.5699 38.6396 25.8707 37.3111 24.6122 36.9615L7.34194 31.5776C6.92242 31.4378 6.78259 31.0183 6.92243 30.6687L14.0543 15.7758C14.3339 15.2164 14.3339 14.3774 13.4949 14.0977C13.2152 13.9578 12.6558 13.818 12.0965 14.0977C11.7469 14.3074 11.6071 14.5172 11.3274 15.0066L3.42644 32.137C3.21668 32.4866 3.42642 32.9761 3.84594 33.1159L22.0251 39.6184C22.3747 39.7583 22.5845 40.1079 22.5146 40.5274L17.5503 63.2513C17.4104 64.0205 18.3194 64.5099 18.8088 63.9505L48.3849 33.5354C49.224 32.6964 49.2938 31.2281 47.7556 30.8085L35.7993 28.1516C35.5197 28.0817 35.3798 27.7321 35.5196 27.5223L47.8955 8.15449C48.5247 7.24553 48.0353 6.05692 46.9865 5.77724L27.2691 0.882848C26.9195 0.812928 26.5699 0.812911 26.2203 0.95275L15.9421 5.07804C15.0331 5.2878 15.1031 6.75608 16.1519 6.96584Z'
        fill='#444B54'
      />
      <g filter='url(#filter0_dd_5002_2459)'>
        <path
          d='M79.0796 59.087L74.1152 23.3305H81.8064L84.7431 47.6088L87.4 23.3305H95.0912L90.1269 59.087H79.0796Z'
          fill='white'
        />
        <path
          d='M98.4474 56.7914C96.7693 55.0522 95.9302 52.5479 95.9302 49.3479V32.374C95.9302 29.3131 96.7693 26.9479 98.4474 25.4174C100.125 23.887 102.643 23.0522 105.859 23.0522C109.075 23.0522 111.592 23.8174 113.27 25.4174C114.948 27.0174 115.788 29.3131 115.788 32.374V49.3479C115.788 52.5479 114.948 55.0522 113.27 56.7914C111.592 58.5305 109.075 59.4348 105.859 59.4348C102.643 59.4348 100.125 58.5305 98.4474 56.7914ZM107.327 52.0609C107.607 51.5044 107.677 50.7392 107.677 49.7653V32.3044C107.677 31.5392 107.537 30.9131 107.327 30.4261C107.117 29.9392 106.628 29.7305 105.929 29.7305C104.6 29.7305 103.901 30.6349 103.901 32.4436V49.8349C103.901 50.8783 104.041 51.6435 104.321 52.1305C104.6 52.687 105.09 52.8957 105.859 52.8957C106.558 52.8957 107.047 52.6174 107.327 52.0609Z'
          fill='white'
        />
        <path
          d='M118.584 59.087V23.4001H126.695V53.0348H135.015V59.087H118.584Z'
          fill='white'
        />
        <path
          d='M137.463 59.087V30.2175H132.638V23.3305H150.328V30.2175H145.503V59.087H137.463Z'
          fill='white'
        />
        <path
          d='M152.076 23.4001H168.227V30.287H160.257V37.9392H167.878V44.687H160.257V52.2H168.717V59.1566H152.076V23.4001Z'
          fill='white'
        />
        <path
          d='M170.465 59.087L174.8 40.8609L171.374 23.4001H179.275L181.372 35.7131L183.19 23.4001H191.161L187.665 40.8609L192 59.087H183.82L181.302 45.1044L178.715 59.087H170.465Z'
          fill='white'
        />
      </g>
      <defs>
        <filter
          id='filter0_dd_5002_2459'
          x='65.1152'
          y='16.0522'
          width='135.885'
          height='54.3828'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='2' />
          <feGaussianBlur stdDeviation='4.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_5002_2459'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='2' />
          <feGaussianBlur stdDeviation='2' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_5002_2459'
            result='effect2_dropShadow_5002_2459'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_5002_2459'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  );
};

export default AppLogoIconVoltex;
